var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopPageGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 236,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.833
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 191H5m63 15a3 3 0 1 1-.001 6.001A3 3 0 0 1 68 206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 153.088v58.435C131 222.28 122.32 231 111.615 231h-87.23C13.68 231 5 222.28 5 211.523V26.479C5 15.72 13.68 7 24.385 7h53.307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 63.5c0 32.309 26.19 58.5 58.5 58.5S188 95.809 188 63.5 161.81 5 129.5 5 71 31.191 71 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 48-28.836 38.055c-2.484 3.26-7.174 3.913-10.474 1.459a7.511 7.511 0 0 1-.774-.664L100 72.112"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPageGraphic);
export default __webpack_public_path__ + "static/media/desktop-page-graphic.42b857ea795c2059d2f948ff2e95ef26.svg";
export { ForwardRef as ReactComponent };